var excludePropertyNames = ['$$typeof', 'render', 'defaultProps', 'props', 'length', 'prototype', 'name', 'caller', 'callee', 'arguments'];
export function cloneEnumerableProperty(target, origin, excludes) {
  if (excludes === void 0) {
    excludes = excludePropertyNames;
  }
  var compExtraPropertyNames = Object.keys(origin).filter(function (d) {
    return !excludes.includes(d);
  });
  compExtraPropertyNames.forEach(function (d) {
    target[d] = origin[d];
  });
  return target;
}